import { AxiosError } from 'axios';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { alimtalkQueryKeys } from '../../../constants/queryKeys/alimtalk';
import { AlimtalkApiV2 } from '../../../lib/api/alimtalk/AlimtalkApiV2';
import { AlimtalkTemplate } from '../../../types/alimtalk/template';

export const useAlimtalkTemplateDetailQuery = (
  id: number | null,
): UseQueryResult<AlimtalkTemplate, AxiosError> =>
  useQuery(
    alimtalkQueryKeys.templateDetail(id ?? 0),
    () => AlimtalkApiV2.getTemplateDetail(id as number),
    { enabled: id != null },
  );
